import { useNavigate } from "react-router-dom";
import SiteText from './SiteText.jsx';

const Services = () => {
    const navigate = useNavigate();

    return <div>
        <div className="text-5xl font-bold text-center mb-4">
            Our Services
        </div>
        <div className="grid max-lg:justify-center lg:grid-cols-4 mb-24 lg:mb-12">
            {Object.values(SiteText.Services.Data).map((service, index) => 
                <div 
                    key={index} 
                    className="flex flex-col w-[256px] md:w-[384px] h-[384px] md:h-[512px] m-12"
                    onClick={() => navigate(SiteText.SitePaths.Service + service.Title.replaceAll(" ", "-").toLowerCase())}
                >
                    <div className="size-[256px] md:size-[384px]">
                        <img src={service.Image} alt={"Image of " + service.Title} />
                    </div>
                    <div className="h-[128px] text-center">
                        <div className="text-2xl font-bold py-4">
                            {service.Title}
                        </div>
                        <div>
                            {service.DescriptionShort}
                        </div>
                    </div>
                </div>
            )}
        </div>
    </div>
};

export default Services;